import {EBillingHealthStatus} from "../../../../../shared/enums/EBillingHealthStatus";
import {ESubscriptionStatus} from "../../../../../shared/enums/ESubscriptionStatus";

export enum EBillingPeriod {
  Monthly,
  Annually,
}

export interface IBillingHealthSummary {
  successfullyBilled: number;
  failed: number;
  overdue: number;
  dueLater: number;
  excluded: number;
}

export interface IBillingHealthCustomer {
  organizationId: string;
  organizationSubscriptionId: string;
  organizationName: string;
  ownerUsername: string;
  ownerEmail: string;
  subscriptionName: string;
  subscriptionStatus: ESubscriptionStatus;
  billingPeriod: EBillingPeriod;
  billingHealthStatus: EBillingHealthStatus;
  price: number;
  lastBilled: string | null;
  nextBillingDate: string;
  lastSuccessfulChargeAt: string | null;
  latestAttemptAt: string | null;
  latestAttemptSucceeded: boolean | null;
  latestAttemptAmount: number | null;
  latestFailureReason: string | null;
  retryCount: number;
  creditCardLast4: string | null;
  hasPaymentMethod: boolean;
  paysOutsideApp: boolean;
  exclusionReason: string | null;
}

export interface IBillingHealthResponse {
  summary: IBillingHealthSummary;
  totalCount: number;
  data: IBillingHealthCustomer[];
}

export interface IBillingHealthRequest {
  month: string;
  search: string;
  status: EBillingHealthStatus | null;
  gmtOffset: string;
}
